/* eslint-disable */
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, ControlLabel, Form, FormGroup, FormControl } from 'react-bootstrap';
import { NotificationManager } from 'react-notifications';

import changeCase from 'change-object-case';
import { ss, adminBecome, setToken, newOrder, tokenLogin, ok, navTo } from '../utils/util';
import Wrapper from './Wrapper';
import {
  fetchUser,
  fetchOrderSuppliers,
  fetchSuppliers,
  fetchLocations,
  updateOrderSupplier,
  fetchCustomerRelationships,
} from '../actions';


class Magic extends Component {

  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {
    let prevUser = this.props.user;
    tokenLogin(this.props.params.token)
      .then(({ data, status}) => {
        this.props.fetchUser()
          .then(() => {
            if (!ok(status)) {
              navTo('/login');
              return;
            }

            if (prevUser && prevUser.id && prevUser.id != this.props.user.id) {
              // The user was already logged in, but as a different user. Try
              // the magic link again. Shouldn't happen often in real life usage.
              window.location.href = '/m/' + this.props.params.token;
              return;
            }

            let actionData, id;
            console.log('MAGIC LINK', data.login.action, data.login);
            switch (data.login.action) {
              case 'forgot_password':
                navTo('/account');
                break;

              case 'view_team':
                actionData = changeCase.camelKeys(JSON.parse(data.login.data));
                navTo('/team/' + actionData.teamId);
                break;

              case 'view_room':
                actionData = changeCase.camelKeys(JSON.parse(data.login.data));
                navTo('/r/' + actionData.roomSlug + '/' + actionData.roomId);
                break;

              case 'claim':
                actionData = changeCase.camelKeys(JSON.parse(data.login.data));
                navTo('/claim/' + actionData.companyId);
                break;

              case 'gift_cards':
                actionData = changeCase.camelKeys(JSON.parse(data.login.data));
                navTo('/pro/gift-cards');
                break;

              case 'view_escapes':
                actionData = changeCase.camelKeys(JSON.parse(data.login.data));
                navTo('/p/' + actionData.username);
                break;

              case 'escape':
                console.log('actionData',actionData);
                actionData = changeCase.camelKeys(JSON.parse(data.login.data));
                navTo('/e/' + actionData.roomSlug + '/' + actionData.escapeId);
                break;

              case 'unsubscribe':
                actionData = changeCase.camelKeys(JSON.parse(data.login.data));
                navTo('/unsubscribe/' + actionData.key);
                break;

              default:
                console.error('unhandled magic link:', data);
            }
          })
      });
  }

  render() {
    return (
      <Wrapper>
        One moment...
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    isLoggedIn: state.isLoggedIn,
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchUser: () => dispatch(fetchUser()),
    fetchLocations: () => dispatch(fetchLocations()),
    fetchSuppliers: () => dispatch(fetchSuppliers()),
    fetchOrderSuppliers: () => dispatch(fetchOrderSuppliers()),
    updateOrderSupplier: (...args) => dispatch(updateOrderSupplier(...args)),
    fetchCustomerRelationships: () => dispatch(fetchCustomerRelationships()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Magic);



/** WEBPACK FOOTER **
 ** ./src/components/Magic.js
 **/